import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class SearchHelperService {
	constructor() {
	}

	/**
	 * Returns true if all characters in the term appear in order in the target string.
	 * Example: "dx" matches "dulux"
	 */
	public fuzzyMatch(term: string, target: string): boolean {
		if (!target) return false;
		if (term.length > target.length) return false;
		let targetIndex = 0;
		for (let i = 0; i < term.length; i++) {
			const char = term[i];
			targetIndex = target.indexOf(char, targetIndex);
			if (targetIndex === -1) return false;
			targetIndex++;
		}
		return true;
	}
}